import React,{useEffect} from "react";
import "../css/product1.css";
import OwlCarousel from "react-owl-carousel";
import Contact from "./Contact";
import AOS from "aos";
import "aos/dist/aos.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHouse } from "@fortawesome/free-solid-svg-icons";

function Product3() {
  const options = {
    margin: 30,
    responsiveClass: true,
    nav: false,
    dots: true,
    autoplay: true,
    smartSpeed: 1000,
    responsive: {
      0: {
        items: 1,
      },
      400: {
        items: 1,
      },
      600: {
        items: 1,
      },
      700: {
        items: 1,
      },
      1000: {
        items: 1,
      },
    },
  };

  useEffect(() => {
    AOS.init();
  }, []);

  return (
    <div>
  <section
            id="about"
            style={{
                 height: "40vh",
                width: "100%",
                // zIndex: 2,
                backgroundImage: "url(/images/back-abt.jpeg)", 
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover",
                // position: "relative",
            }}
          >
            <div className="container">
              <div
                className="breadcrumbt"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  height: "100%",
                  padding: "160px",
                  boxSizing: "border-box",
                   width:"100%"
                }}
              >
                <div style={{ backgroundColor: "rgba(0, 0, 0, 0.5)",padding: "10px", borderRadius: "8px", textAlign: "center", marginBottom: "15px" }}>
                  <h1 className="abtus-heading" style={{ color: "white" }}>
                   Products
                  </h1>
                </div>

                <div>
                  <Breadcrumb style={{backgroundColor: "rgba(0, 0, 0, 0.5)", padding: "10px", borderRadius: "8px", display: "inline-block", textAlign: "center" }}>
                    <FontAwesomeIcon
                      icon={faHouse}
                      style={{
                        fontSize: "14px",
                        marginTop: "0px",
                        color: "white",
                        padding: "5px",
                      }}
                    />
                    <Breadcrumb.Item href="/" style={{ color: "white" }}>
                      Home
                    </Breadcrumb.Item>
                    <Breadcrumb.Item active style={{ color: "white" }}>
                     Products
                    </Breadcrumb.Item>
                  </Breadcrumb>
                </div>
              </div>
            </div>
          </section>

<div className="mainp" style={{marginTop: "10px"}}>

<div className="product-main">
        <div className="lftside">
          <OwlCarousel loop margin={5} nav {...options} className="owlslide">
            <div class=" verticleCard">
              <img
                src="../images/coirfiber/coir-fiber-4-m5KvaoERrJcZW3DB.avif"
                alt=""
                srcset=""
                data-aos="fade-down"
              />
            </div>
            <div class=" verticleCard">
              <img
                   src="../images/coirfiber/coir-fiber-6-A85pLPGDJLFZlMzk.avif"
                alt=""
                srcset=""
                data-aos="fade-down"
              />
            </div>
            <div class=" verticleCard">
              <img
                          src="../images/coirfiber/coir-fiber-bale-6-YbNal8w5Vzugba3N.avif"
                alt=""
                srcset=""
                data-aos="fade-down"
              />
            </div>
      
          </OwlCarousel>
        </div>
        <div className="rghtside" data-aos="fade-down">
            <h1>
            What is Coir Fiber and Why Use It?
            </h1>
            <p>
            Coir fiber is a natural material extracted from the husk of coconuts. It is renowned for its durability, versatility, and eco-friendliness, making it an excellent choice for a variety of applications. Here’s why you should consider using coir fiber:    </p>
        </div>

        </div>

 <div className="container"  style={{color:"#fff"}}>
    <div className="row w-100 ">
<div className="col-md-9 border p-3 myCol" data-aos="fade-down" >
<h4>
Durable and Strong
</h4>
<ul className="text-start">
    <li>
    High Tensile Strength: Coir fiber is known for its exceptional strength and resilience, making it ideal for products that need to withstand heavy use and harsh conditions.    </li>
    <li>
    Longevity: Naturally resistant to rot, mold, and moisture, coir fiber products have a longer lifespan compared to many other natural fibers. </li>
</ul>
</div>
    </div>

    <div className="row w-100  mt-3">
<div className="col-md-9 border offset-3 p-3 myCol" data-aos="fade-down">
<h4>
Eco-Friendly and Sustainable


</h4>
<ul className="text-start">
    <li>
    Renewable Resource: Coir fiber is derived from coconut husks, a byproduct of the coconut industry, making it a sustainable and environmentally friendly material.
    </li>
    <li>
    Biodegradable: Coir fiber decomposes naturally over time, reducing waste and environmental impact.
    </li>
</ul>
</div>
    </div>

    <div className="row w-100  mt-3">
<div className="col-md-9 border myCol  p-3"  data-aos="fade-down">
<h4>
Versatile Applications
</h4>
<ul className="text-start">
    <li>
    Gardening and Agriculture: Used in grow bags, mulch mats, and soil amendments, coir fiber promotes healthy plant growth by providing excellent water retention and aeration.   
</li>
<li>
Home and Industrial Uses: Commonly used in products such as coir mats, rugs, ropes, and brushes, offering durability and aesthetic appeal.
</li>
<li>
Erosion Control: Effective in preventing soil erosion and promoting vegetation growth, coir fiber is used in geotextiles and erosion control blankets.
</li>
</ul>
</div>
    </div>

    <div className="row w-100  mt-3">
<div className="col-md-9 border offset-3 p-3 myCol" data-aos="fade-down" >
<h4>
Excellent Water Retention and Aeration
</h4>
<ul>
  <li>
  Optimal Hydration: Coir fiber retains water efficiently, ensuring that plants receive consistent moisture levels.
  </li>
  <li>
  Improved Soil Structure: Enhances aeration, preventing waterlogging and promoting healthy root development.
  </li>
</ul>

</div>
    </div>

    <div className="row w-100  mt-3">
<div className="col-md-9 border p-3 myCol" data-aos="fade-down">
<h4>
Natural Pest Resistance
</h4>
<ul className="text-start">
    <li>
    Pest Deterrent: Naturally resistant to pests and microbial attacks, reducing the need for chemical treatments and making it a safer choice for organic farming and gardening.
  </li>
   
</ul>
</div>
    </div>
 </div>
</div>
<Contact/>

    </div>
  );
}

export default Product3;
